import { useLocation, Link } from "react-router-dom";
import { storyElement } from "@/lib/story-element";
import { useEffect } from "react";
import { PageContainer } from "@/components/layout/PageContainer";
import { useLocale } from "@/hooks/useLocale";
import { usePageMeta } from "@/hooks/usePageMeta";

const NotFound = () => {
  const location = useLocation();
  const { t } = useLocale();

  usePageMeta({
    title: "Page Not Found — Adventure Venture",
    description: "The page you're looking for doesn't exist. Return to Adventure Venture.",
    noindex: true,
  });

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <PageContainer width="narrow" center>
      <div {...storyElement("page-not-found")} className="text-center space-y-4">
        <h1 className="text-4xl font-bold text-foreground">{t.notfound_title}</h1>
        <p className="text-xl text-muted-foreground">{t.notfound_desc}</p>
        {/* W20: use React Router Link instead of <a href> to avoid full-page reload */}
        <Link to="/" className="text-primary underline hover:text-primary/80">
          {t.notfound_back}
        </Link>
      </div>
    </PageContainer>
  );
};

export default NotFound;
